import React, { useEffect, useRef, useState } from "react";
import Seo from "../../../components/Seo/seo";
import Layout from "../../../components/Layout/layout";
import HeroSection from "../../../components/MLPMainComp/HeroSection/heroSection";
import GoTo from "../../../components/MLPMainComp/GoTo/goTo";
import NavBar from "../../../components/NavBar/navbar";
import Overview from "../../../components/MLPMainComp/Overview/overview";
import Benefits from "../../../components/MLPMainComp/Benefits/benefits";
import AdmissionProcess from "../../../components/MLPMainComp/AdmissionProcess/admissionProcess";
import Curriculum from "../../../components/MLPMainComp/Curriculum/curriculum";
import Specialisations from "../../../components/MLPMainComp/Specialisations/specialisations";
import Faq from "../../../components/MLPMainComp/FAQS/faq";
import OverviewTitle from "../../../components/MLPMainComp/Overview/OverviewTitle";
import Placements from "../../../components/MLPMainComp/Placements/placements";
import PlacementsMain from "../../../components/MLPMainComp/Placements";
import Recruiters from "../../../components/MLPMainComp/Placements/Recruiters";
import Roles from "../../../components/MLPMainComp/Roles/Roles";
import AlumniCarousal from "../../../components/MLPMainComp/Placements/AlumniCarousal";
// import WhatsappWidget from "../../components/WhatsappWidget";
import LearningProcess from "../../../components/MLPMainComp/LearningProcess/LearningProcess";
import MLPMainTools from "../../../components/MLPMainComp/DMM-tools";
import Leaders from "../../../components/MLPMainComp/Leaders/index";
import Fee from "../../../components/MLPMainComp/FeeNew/fee";
import CourseTracks from "../../../components/MLPMainComp/Tracks/CourseTracks";

import {
  videoSnipptJSON,
  eventSnipptJSON,
} from "../../../components/Seo/mlpSeoData";

import "./styles.scss";
import Certification from "../../../components/MLPMainComp/Certification";
import MLPForm from "../../../components/Forms/MLPForm";
import IvrSection from "../../../components/MLPMainComp/Ivr";
// import ThankYou from "../../components/Forms/ThankYou";
import { useLocation } from "@reach/router";
import ContactUsPopup from "../../../components/ContactUsPopup";
import NewsSection from "../../../components/MLPMainComp/NewsSection/NewsSection";

const MarketingLaunchPad = (props) => {
  const location = useLocation();
  const navBarContent = [
    // {
    //   name: "Overview",
    //   id: "overview",
    // },
    {
      name: "Placements",
      id: "placements",
    },
    {
      name: "Benefits",
      id: "benefits",
    },
    {
      name: "Curriculum",
      id: "Curriculum",
    },
    {
      name: "Experts",
      id: "trainers",
    },
    {
      name: "Admissions",
      id: "admissions",
      mobileHide: false,
      desktopHide: false,
    },
    // {
    //   name: "Fee",
    //   id: "fee",
    // },
  
    {
      name: "FAQS",
      id: "faq",
    },
    {
      name: "Apply Now",
      id: "HeroSection",
      //formLink: true,
    },
  ];


  const [isHidden, setIsHidden] = useState(true);

  const [showContactUsPopup, setContactUsPopup] = useState(false);

  const contactUsTimeout = useRef(null);

  useEffect(() => {

    contactUsTimeout.current = setTimeout(() => {
      setContactUsPopup(true);
    }, 40 * 1000);

    function handleScroll() {
      const currentScrollPosition = window.pageYOffset;

      setIsHidden(currentScrollPosition < 1400); // Change 100 to the number of pixels after which you want to hide the element
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);

      if(contactUsTimeout.current)
        clearTimeout(contactUsTimeout.current);
    };
  }, []);

  return (
    <React.Fragment>
      <Seo
        title="Best Online Digital Marketing Course with Placement [& AI Tools Training]"
        description="India's best online digital marketing course with placements of 4.5 LPA and above. A 16 week course with an 8 week paid internship + full-time jobs. Enroll now!"
        url="https://www.kraftshala.com/marketing-launchpad/digital-marketing-course/"
        // courseSnipptJSON={courseSnipptJSON}
        // faqSnipptJSON={faqSnipptJSON}
        videoSnipptJSON={videoSnipptJSON}
        eventSnipptJSON={eventSnipptJSON}
      />
      {showContactUsPopup && <ContactUsPopup />}
      <div id="HeroSection" className="main-mlp-page">
        <Layout formLink="/marketing-launchpad/digital-marketing-course/">
          <div className="hero-div mb-0" id="hero-div">
            <HeroSection urlParams={location.search} />
            <MLPForm search={location.search} pathname={location?.pathname} locState={location?.state}>
              {/* <ThankYou formfields={location?.state?.formFields} campaignId={location?.state?.campaignId} /> */}
            </MLPForm>
          </div>
          <GoTo />
          <div className="mlp-main-overview bg-mob-size">
            <div className="element-center">
              <OverviewTitle />
            </div>
            <NavBar
              content={navBarContent}
              applyLink={`/marketing-launchpad/digital-marketing-course/${location.search}`}
            />

            <Overview />

            <div className={isHidden ? "fixed-bottomHidden" : "fixed-bottom"}>
              {!isHidden && (
                <>
                  {" "}
                  <button
                    className={"footer-btn"}
                    onClick={() => {
                      document.querySelector("#hero-div").scrollIntoView({
                        behavior: "smooth",
                        block: "end",
                        inline: "nearest",
                      });
                    }}
                  >
                    Start my marketing career
                  </button>
                  {/* <div className="text">
                    {" "}
                    Digital marketing course{" "}
                    <span className="yellow-text">so good</span>, you only{" "}
                    <span className="yellow-text">pay after placement</span>
                  </div>{" "} */}
                </>
              )}
            </div>
            <div id="placements" className="section">
              <PlacementsMain />
            </div>

            <div id="Roles" className="section">
              <Recruiters />
              <Roles />
            </div>

            <div id="testimonials" className="section">
              <AlumniCarousal />
            </div>

            <div id="benefits" className="section">
              <Benefits />
            </div>

            <div id="Duration" className="section">
              <LearningProcess urlParams={location.search} />
            </div>

           

            <div id="specializations" className="section">
              <Specialisations />
              <Curriculum />
            </div>

            <div id="tools" className="section">
              <MLPMainTools />
            </div>

            <div  className="section">
              <Certification />
            </div>

            <div id="trainers" className="section">
              <Leaders />
            </div>

            <div id="Placements" className="section">
              <Placements />
            </div>

            <div id="admissions" className="section">
              <AdmissionProcess urlParams={location.search} />
            </div>

            <div id="fee" className="section">
              <Fee />
             
            </div>

            
            <div id="news-section" className="section">
              <NewsSection />
            </div>

            <div id="courses" className="section">
              <CourseTracks />
            </div>

            <div id="ivr" className="section">
              <IvrSection />
            </div>

            <div id="faq" className="section">
              <Faq />
            </div>
          </div>
        </Layout>
      </div>
      {/* <WhatsappWidget link="https://wa.me/message/HHNAOZDIMB4ZE1" /> */}
    </React.Fragment>
  );
};

export default MarketingLaunchPad;
